<template>
<div class="faq" :class="{ 'faq--home': variant === 'home' }">
    <div
        v-for="(item, index) in faqs"
        :key="index"
        class="dropdown-faq"
        :class="{ 'is-open': activeIndex === index }">
        <button
            type="button"
            class="faq-title"
            :aria-expanded="activeIndex === index"
            @click="toggleFaq(index)">
            <span>{{ item.question }}</span>
            <img
                v-if="variant !== 'home'"
                src="../assets/down-black.svg"
                alt=""
                :class="{ rotate: activeIndex === index }"
                loading="lazy">
            <span
                v-else
                class="faq-chevron"
                :class="{ rotate: activeIndex === index }"
                aria-hidden="true" />
        </button>

        <div v-if="activeIndex === index" class="content" v-html="item.answer" />
    </div>
</div>
</template>

<script>
export default {
    props: {
        faqs: {
            type: Array,
            required: true
        },
        /** default：指南页；home：首页 GB Wave 风格 */
        variant: {
            type: String,
            default: 'default',
            validator: (v) => ['default', 'home'].includes(v)
        }
    },
    data() {
        return {
            activeIndex: null
        }
    },
    methods: {
        toggleFaq(index) {
            if (this.activeIndex === index) {
                this.activeIndex = null
            } else {
                this.activeIndex = index
            }
        }
    }
}
</script>

<style scoped>
.faq {
    width: 100%;
    margin-top: 0.85rem;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.dropdown-faq {
    border: 1px solid #dfece4;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(24, 76, 43, 0.05);
    overflow: hidden;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.dropdown-faq.is-open {
    border-color: #b7dbc6;
    box-shadow: 0 10px 24px rgba(24, 76, 43, 0.08);
}

.faq-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 0;
    padding: 14px 16px;
    gap: 12px;
    border: 0;
    background: transparent;
    color: #141a22;
    font: inherit;
    font-size: 0.98rem;
    font-weight: 700;
    line-height: 1.35;
    text-align: left;
    cursor: pointer;
    transition: background 0.18s ease;
}

.faq-title:hover {
    background: #f7fbf8;
}

.dropdown-faq.is-open .faq-title {
    background: #f4faf6;
}

.faq-title span {
    min-width: 0;
}

.faq-title img {
    flex: 0 0 auto;
    width: 18px;
    height: 18px;
    margin-left: 8px;
    transition: transform 0.2s ease;
}

.faq-title img.rotate {
    transform: rotate(180deg);
}

.faq-title:focus-visible {
    outline: 2px solid #0a9c36;
    outline-offset: -2px;
}

.content {
    margin: 0;
    padding: 0 16px 14px;
    color: #5b6573;
    font-size: 0.9rem;
    line-height: 1.55;
    border-top: 1px solid #e8f0eb;
    background: #fafdfb;
}

/* —— 首页适配：与 install-steps / feature 卡统一 —— */
.faq--home {
    margin-top: 1.15rem;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.faq--home .dropdown-faq {
    border: 1px solid #dfece4;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(24, 76, 43, 0.05);
    overflow: hidden;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.faq--home .dropdown-faq.is-open {
    border-color: #b7dbc6;
    box-shadow: 0 10px 24px rgba(24, 76, 43, 0.08);
}

.faq--home .faq-title {
    min-height: 0;
    padding: 14px 16px;
    gap: 12px;
    color: #141a22;
    font-size: 0.98rem;
    font-weight: 700;
    line-height: 1.35;
    transition: background 0.18s ease;
}

.faq--home .faq-title:hover {
    background: #f7fbf8;
}

.faq--home .dropdown-faq.is-open .faq-title {
    background: #f4faf6;
}

.faq--home .faq-chevron {
    flex: 0 0 auto;
    width: 10px;
    height: 10px;
    margin: 0 2px 0 8px;
    border-right: 2px solid #0a9c36;
    border-bottom: 2px solid #0a9c36;
    transform: rotate(45deg);
    transition: transform 0.2s ease;
}

.faq--home .faq-chevron.rotate {
    transform: rotate(225deg);
    margin-top: 4px;
}

.faq--home .faq-title:focus-visible {
    outline: 2px solid #0a9c36;
    outline-offset: -2px;
}

.faq--home .content {
    padding: 12px 16px 16px;
    color: #5b6573;
    font-size: 0.9rem;
    line-height: 1.7;
    border-top: 1px solid #e8f0eb;
    background: #fafdfb;
}

.faq--home .content ::v-deep strong {
    color: #0d3d2a;
    font-weight: 700;
}

.faq--home .content ::v-deep a {
    color: #0066cc;
}

@media (max-width: 640px) {
    .faq {
        padding: 0;
    }

    .faq-title {
        min-height: 42px;
        padding-right: 6px;
        font-size: 1rem;
    }

    .content {
        padding-right: 28px;
        font-size: 0.94rem;
    }

    .faq--home .faq-title {
        padding: 13px 14px;
        font-size: 0.94rem;
    }

    .faq--home .content {
        padding: 0 14px 13px;
        font-size: 0.88rem;
    }
}
</style>
